import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import VideoPlayerModal from '../common/VideoPlayerModal';
import ImageViewer from '../common/ImageViewer';

const VRTraining = () => {
    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null)
    const [imageUrl, setImageUrl] = useState(null)
    const [chooseModal, setChooseModal] = useState(null)

    const imageDiv = []

    for (let index = 0; index < 18; index++) {

        imageDiv.push(
            <Col xs={{span:6, offset:0}} md={{span:4, offset:0}} className="no-padding-x" key={index}>
                <Card.Img onClick={() => openImageModal(index)} className='img img-thumbnail training-images' src={process.env.PUBLIC_URL + "assets/vr-development/vr-trainings/equipment-operator/"+index+".jpg"} />
            </Col>
        )        
    }

    const openVideoModal = (data) => {
        setModalShow(true)
        setChooseModal('video')
        setVideoUrl(data)

    }

    const openImageModal = (data) => {
        setModalShow(true)
        setChooseModal('image')
        setImageUrl(data)
    }

  return (
    <>
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'>VR Training</Card.Title>
                <Card.Subtitle className="py-2 py-md-4 big-subtitle">High-impact learning</Card.Subtitle>
                <Card.Text className='industrial-environment-text'>
                Immersive technology offers a number of advantages over traditional training methods. Provide new employees with detailed and immersive demonstrations and simulated situations that don’t (or shouldn’t) happen often.
                </Card.Text>

                <Row>
                    <Col xs={{span:12, offset:0}} md={{span:8, offset:2}}>
                        <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('assets/vr-development/vr-trainings/video/Dromex.mp4')}>
                            <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/vr-trainings/trainging-banner.jpg"} />
                            <Card.ImgOverlay className='playicon-overlay-center'>
                                <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                            </Card.ImgOverlay>

                        </Card>
                    </Col>
                </Row>

                <Card.Subtitle className="industrial-modeling-subtitle py-4">Hazardous Situation Simulation</Card.Subtitle>
                <Card.Text className='industrial-environment-text'>
                Employees may need to train for rare or hazardous situations—in mines, on construction sites, in healthcare facilities, on first-responder calls. Virtual reality allows trainees to experience simulated situations from the safety of a VR headset. They learn to react and follow protocol without any of the cost or risk.
                </Card.Text>
                <Row>
                    <Col xs={{span:12, offset:0}} md={{span:6, offset:3}}>
                        <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/vr-trainings/harardious.jpg"} />
                    </Col>
                </Row>
                <Card.Subtitle className="industrial-modeling-subtitle py-4">Equipment Operator Training</Card.Subtitle>
                <Card.Text className='industrial-environment-text'>
                Training new equipment operators is a prime use case for VR. Let them get familiar with new equipment in the safety of a simulated environment—without taking machines offline for training or risking expensive and dangerous incidents.
                </Card.Text>
                <Row className='px-md-4'>
                    {imageDiv}
                </Row>
            </Card.Body>
        </Card>
        
       
        {chooseModal === "video" && 
             <VideoPlayerModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                videosrc={videoUrl}
           />
        }

        {chooseModal === 'image' &&
            <ImageViewer 
                show={modalShow}
                onHide={() => setModalShow(false)}
                imagesrc={imageUrl}
                imagedir="assets/vr-development/vr-trainings/equipment-operator/enlarge/"
                imagecounter={17}
                mimetype='jpg'
            />
        }
    </>
  )
}

export default VRTraining
